'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const Relay = require('react-relay');
const get = require('lodash.get');
const constants = require('../../constants/detailsConstants.es');
const copy = require('../../../../../json/copy/pdp.json');
const styles = require('./ProductionLeadTime.scss');

function ProductionLeadTime({ relayItem: item }) {
    const leadTimeValue = get(item, 'attributes.leadTime[0].value');

    if (!leadTimeValue || leadTimeValue === constants.availableNow) {
        return null;
    }

    return (
        <div className="pdp-product-lead-time">
            <span className={styles.title}>{copy.productionTime.title}</span>
            {leadTimeValue}
        </div>
    );
}

ProductionLeadTime.propTypes = {
    relayItem: PropTypes.object
};

const Connected = Relay.createContainer(ProductionLeadTime, {
    fragments: {
        relayItem: () => Relay.QL`
            fragment on Item {
                attributes {
                    leadTime {
                        value
                    }
                }
            }
        `
    }
});

module.exports = {
    Raw: ProductionLeadTime,
    Connected
};



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Shipping/ProductionLeadTime.jsx